import store from "../store/store";
import axios from "axios";

export const formioRequest = axios.create({
  baseURL: "https://formio.mobilecoveragemap.com/form/",
});
export const formioRequestAdmin = axios.create({
  baseURL: "https://formio.mobilecoveragemap.com/form/",
});
